import axios from "axios";

export const getServices = async () => {
  const res = await axios.get("https://alnabaatech.com.ly/api/services");
  return res.data.data;
};